/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL } from '../constants';
import './Clip.css';

const Clip = props => {
  const { artist, category, videoSrc, images } = props;

  return (
    <div className={`clip ${category} ${artist}`}>
      <div
        className='video-static-overlay'
        style={{
          background: `url(${BASE_URL}/images/play.png) 50% no-repeat`,
          backgroundSize: 'contain',
        }}
      />
      {videoSrc && (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video controls poster={`${BASE_URL}${images.large}`}>
          <source src={`${BASE_URL}${videoSrc}.mp4`} type='video/mp4' />
          <source src={`${BASE_URL}${videoSrc}.webm`} type='video/webm' />
        </video>
      )}
    </div>
  );
};

Clip.defaultProps = {
  artist: '',
  category: '',
  videoSrc: null,
  images: {},
};

Clip.propTypes = {
  artist: PropTypes.string,
  category: PropTypes.string,
  images: PropTypes.objectOf(PropTypes.string),
  videoSrc: PropTypes.string,
};

export default Clip;
